import { jsxs as e, jsx as r, Fragment as Q } from "react/jsx-runtime";
import { c as i } from "../../../clsx-OuTLNxxd.js";
import { IMAGE_URL as V, IMAGE_URL_BADGE as X } from "../../../config/destination.js";
import "react";
import "../../../button.types-DcITT54g.js";
import "../button/iconButton/iconButton.js";
import { I as o } from "../../../icon-CCupal-M.js";
import "../icon/iconsList.js";
import "../carousel/carousel.js";
import { T as m } from "../../../text-CCLkQO4k.js";
import { Title as Y } from "../title/title.js";
import "../inputs/input/input.js";
import "../inputs/checkbox/checkbox.js";
import "../inputs/radio/radio.js";
import "../inputs/dateRangePicker/dateRangePicker.js";
import { Tag as u } from "../tag/tag.js";
import "../toast/toast.context.js";
import "../../../map-BcfLql3E.js";
import { Flex as Z } from "../../layout/flex/flex.js";
import { useCardCarousel as T } from "./card.hook.js";
const B = "_card_123au_29", S = "_tag_123au_88", aa = "_arrow_123au_122", ra = "_prev_123au_152", ea = "_next_123au_156", ca = "_active_123au_183", a = {
  card: B,
  "card-map": "_card-map_123au_33",
  "card-slider-container": "_card-slider-container_123au_39",
  "card-content": "_card-content_123au_42",
  "card-img-wrapper": "_card-img-wrapper_123au_45",
  "card-flexible-search": "_card-flexible-search_123au_49",
  "card-img-user-button": "_card-img-user-button_123au_55",
  "card-img-user": "_card-img-user_123au_55",
  "card-list": "_card-list_123au_65",
  "card-badge": "_card-badge_123au_85",
  tag: S,
  "is-low": "_is-low_123au_97",
  "is-average": "_is-average_123au_103",
  "is-great": "_is-great_123au_109",
  "is-excellent": "_is-excellent_123au_115",
  arrow: aa,
  "arrow-icon": "_arrow-icon_123au_143",
  prev: ra,
  next: ea,
  "pagination-slider": "_pagination-slider_123au_160",
  active: ca,
  "card-slider-wrapper": "_card-slider-wrapper_123au_208",
  "card-slider-item": "_card-slider-item_123au_213",
  "card-no-image": "_card-no-image_123au_221",
  "card-img": "_card-img_123au_45",
  "card-icons": "_card-icons_123au_243",
  "card-fav": "_card-fav_123au_254",
  "card-fav-active": "_card-fav-active_123au_259",
  "card-close": "_card-close_123au_264",
  "card-verify": "_card-verify_123au_294",
  "card-title-wrapper": "_card-title-wrapper_123au_297",
  "card-title-content-text": "_card-title-content-text_123au_304",
  "card-title-content": "_card-title-content_123au_304",
  "card-title": "_card-title_123au_297",
  "card-title-link": "_card-title-link_123au_326",
  "card-review": "_card-review_123au_334",
  "card-location": "_card-location_123au_343",
  "card-flexible-search-text": "_card-flexible-search-text_123au_358",
  "no-availabilities": "_no-availabilities_123au_362",
  "card-dot": "_card-dot_123au_365",
  "card-footer": "_card-footer_123au_369",
  "card-gp-wrapper": "_card-gp-wrapper_123au_374",
  "card-gp": "_card-gp_123au_374",
  "dialog-overlay-show": "_dialog-overlay-show_123au_1",
  "dialog-content-show": "_dialog-content-show_123au_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_123au_1"
}, I = `${V}/placeholders/home_gallery.svg`;
function ka({
  format: l = "list",
  images: t,
  userImg: v,
  title: n,
  location: L,
  GPCostByNightText: G,
  verify: P = !1,
  flexibleSearch: _,
  flexibleSearchText: h,
  rating: N,
  reviews: f,
  loyaltyBadge: p,
  isCollection: w = !1,
  isCollectionTagText: b,
  isPrivateRoom: R = !1,
  isPrivateRoomTagText: x,
  alreadyContacted: z = !1,
  alreadyContactedTagText: k,
  hasMinimumOfNights: U,
  hasMinimumOfNightsTagText: D,
  displayFavorite: F,
  isFavorite: y,
  showBeds: A,
  bedsText: H,
  showBedrooms: C,
  bedroomsText: M,
  url: E,
  onClickUser: j,
  onFavorite: O,
  onClose: W,
  onTracking: q
}) {
  const { currentIndex: d, move: $, sliderRef: J, touchHandlers: K } = T(t.length), g = l === "search" ? t.length > 0 ? t : [I] : t.length > 0 ? t.slice(0, 1) : [I];
  return /* @__PURE__ */ e("div", { className: i(a.card, a[`card-${l}`]), children: [
    E && /* @__PURE__ */ r(
      "a",
      {
        className: a["card-title-link"],
        target: "_blank",
        title: n,
        href: E,
        rel: "noreferrer noopener",
        onClick: () => q?.()
      }
    ),
    /* @__PURE__ */ e("div", { className: a.tag, children: [
      w && b && /* @__PURE__ */ r(u, { text: b, color: "collection", size: "small" }),
      R && !w && x && /* @__PURE__ */ r(u, { text: x, color: "secondary-highlight", size: "small" }),
      z && k && /* @__PURE__ */ r(u, { text: k, color: "secondary-info", size: "small" }),
      U && !z && /* @__PURE__ */ r(u, { text: D, color: "tertiary-info", size: "small" })
    ] }),
    /* @__PURE__ */ e("div", { className: a["card-img-wrapper"], children: [
      /* @__PURE__ */ r("div", { className: a["card-slider-container"], ...K, children: /* @__PURE__ */ r("div", { className: a["card-slider-wrapper"], ref: J, children: g?.map((c, s) => /* @__PURE__ */ r("div", { className: i(a["card-slider-item"]), children: /* @__PURE__ */ r(
        "img",
        {
          className: i(a["card-img"], t.length === 0 && a["card-no-image"]),
          src: c,
          alt: n,
          loading: "lazy"
        }
      ) }, s)) }) }),
      l === "search" && d !== g.length - 1 && /* @__PURE__ */ r(
        "button",
        {
          className: i(a.arrow, a.next),
          color: "secondary",
          onClick: () => $("next"),
          "aria-label": "Next image",
          children: /* @__PURE__ */ r("div", { className: a["arrow-icon"], children: /* @__PURE__ */ r(o, { name: "arrow-thin", size: "medium" }) })
        }
      ),
      l === "search" && d !== 0 && /* @__PURE__ */ r(
        "button",
        {
          className: i(a.arrow, a.prev),
          color: "secondary",
          onClick: () => $("prev"),
          "aria-label": "Previous image",
          children: /* @__PURE__ */ r("div", { className: a["arrow-icon"], children: /* @__PURE__ */ r(o, { name: "arrow-thin", size: "medium" }) })
        }
      ),
      l === "search" && g.length > 1 && /* @__PURE__ */ r("div", { className: a["pagination-slider"], children: t.map((c, s) => /* @__PURE__ */ r(
        "span",
        {
          className: i(
            d === s && a.active,
            d - 1 === s && a.prev,
            d + 1 === s && a.next
          ),
          style: {
            left: `${24 - d * 12}px`
          }
        },
        s
      )) }),
      v && /* @__PURE__ */ e(
        "button",
        {
          className: a["card-img-user-button"],
          onClick: (c) => {
            c.stopPropagation(), j?.(c);
          },
          "aria-label": "User image",
          children: [
            /* @__PURE__ */ r("img", { className: a["card-img-user"], src: v, alt: n, width: 56, height: 56, loading: "lazy" }),
            p && l !== "map" && /* @__PURE__ */ r(
              "img",
              {
                className: a["card-badge"],
                src: `${X}/badge-${p > 9 ? "9" : p}.svg`,
                alt: `Lotalty badge ${p}`,
                loading: "lazy"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ e("div", { className: a["card-icons"], children: [
        F && /* @__PURE__ */ r(
          "button",
          {
            onClick: (c) => {
              c.stopPropagation(), O?.(c);
            },
            "aria-label": y ? "Remove from favorites" : "Add to favorites",
            children: /* @__PURE__ */ r(
              o,
              {
                className: i(a["card-fav"], y && a["card-fav-active"]),
                name: "heart-fill",
                size: "2xl"
              }
            )
          }
        ),
        l === "map" && /* @__PURE__ */ r(
          "button",
          {
            onClick: (c) => {
              c.stopPropagation(), W?.();
            },
            "aria-label": "Close home card",
            className: a["card-close"],
            children: /* @__PURE__ */ r(o, { name: "circle-close", size: "2xl", color: "inverted" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: i(a["card-content"]), children: [
      /* @__PURE__ */ e("div", { className: a["card-title-wrapper"], children: [
        /* @__PURE__ */ e("div", { className: a["card-title-content"], children: [
          P && /* @__PURE__ */ r(o, { className: a["card-verify"], name: "checkbox-fill", size: "large", color: "secondary" }),
          /* @__PURE__ */ r("span", { className: a["card-title-content-text"], children: /* @__PURE__ */ r(Y, { level: 3, className: a["card-title"], title: n, hasHeaderTag: !0, children: n }) })
        ] }),
        N && /* @__PURE__ */ e(m, { className: a["card-review"], children: [
          /* @__PURE__ */ r(o, { name: "star-full", size: "medium", color: "dark" }),
          " ",
          N,
          f && ` (${f})`
        ] })
      ] }),
      /* @__PURE__ */ e(Z, { direction: "column", gap: "1", isFullWidth: !0, children: [
        /* @__PURE__ */ r(m, { className: a["card-location"], children: L }),
        /* @__PURE__ */ e(m, { children: [
          C && M,
          C && A ? /* @__PURE__ */ r("span", { className: a["card-dot"], children: "•" }) : "",
          A && H
        ] }),
        (_ && h || !_ && h) && /* @__PURE__ */ e(m, { className: a["card-flexible-search"], children: [
          /* @__PURE__ */ r(
            "span",
            {
              className: i(a["card-flexible-search-text"], !_ && a["no-availabilities"]),
              children: h
            }
          ),
          _ && /* @__PURE__ */ e(Q, { children: [
            /* @__PURE__ */ r("span", { className: a["card-dot"], children: "•" }),
            _
          ] })
        ] })
      ] }),
      /* @__PURE__ */ r("div", { className: a["card-footer"], children: /* @__PURE__ */ r("div", { className: a["card-gp-wrapper"], children: /* @__PURE__ */ r(m, { className: a["card-gp"], children: G }) }) })
    ] })
  ] });
}
export {
  ka as Card
};
